import { module } from "angular";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IManufacturer, IResponse } from "App/Modules/Models";

import type { IManufacturersRepository } from "./IManufacturersRepository";

export default class ManufacturersRepository implements IManufacturersRepository {
    public static $inject = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getManufacturers(): Observable<IResponse<IManufacturer[]>> {
        return this.httpService.get<IManufacturer[]>("manufacturers");
    }

    public getManufacturer(manufacturerId: string): Observable<IResponse<IManufacturer>> {
        return this.httpService.get<IManufacturer>(`manufacturers/${manufacturerId}`);
    }

    public addManufacturer(manufacturer: IManufacturer): Observable<IResponse<IManufacturer>> {
        return this.httpService.post<IManufacturer>("manufacturers", manufacturer);
    }

    public deleteManufacturer(manufacturerId: string): Observable<IResponse<void>> {
        return this.httpService.delete(`manufacturers/${manufacturerId}`);
    }

    public patchManufacturer(
        manufacturerId: string,
        manufacturerPatch: IManufacturer,
    ): Observable<IResponse<IManufacturer>> {
        return this.httpService.patch<IManufacturer>(`manufacturers/${manufacturerId}`, manufacturerPatch);
    }
}

module("mmRepositories").service("irManufacturersRepository", ManufacturersRepository);
